import React from 'react';
import ListRow from 'Douleutaras/components/Collapsible/ListRow';

import ServicePrice from './ServicePrice';
import { CatalogueService } from './types';

interface ServiceRowProps {
  service: CatalogueService;
  onServiceClick?(): void;
}

/**
 * A single service row, rendered through the reusable {@link ListRow}. `sub1` rows use the
 * strong (bold) emphasis; `sub2` rows use the regular emphasis. Any `sub2` children are
 * rendered as sibling rows.
 *
 * Clicking a row routes into the post-job (booking) flow — the same action as the
 * ProProfile CTA — via the `onServiceClick` callback threaded down from the catalogue.
 */
export const ServiceRow = ({ service, onServiceClick }: ServiceRowProps) => {
  const isSub1 = service.level === 'sub1';
  const children = service.children ?? [];

  return (
    <>
      <ListRow
        label={service.label}
        emphasis={isSub1 ? 'strong' : 'regular'}
        trailing={service.price ? <ServicePrice price={service.price} /> : undefined}
        onClick={onServiceClick}
      />
      {children.map(child => (
        <ServiceRow key={child.serviceId} service={child} onServiceClick={onServiceClick} />
      ))}
    </>
  );
};

export default ServiceRow;
